var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03245 13.5016C6.6665 14.2972 6.6665 15.2024 6.6665 17.0127V22.6666C6.6665 25.1807 6.6665 26.4378 7.44755 27.2189C8.19329 27.9646 9.373 27.9983 11.6665 27.9998V21.3333C11.6665 20.0447 12.7112 19 13.9998 19H17.9998C19.2885 19 20.3332 20.0447 20.3332 21.3333V27.9998C22.6267 27.9983 23.8064 27.9646 24.5521 27.2189C25.3332 26.4378 25.3332 25.1807 25.3332 22.6666V17.0127C25.3332 15.2024 25.3332 14.2972 24.9672 13.5016C24.6013 12.7059 23.914 12.1168 22.5395 10.9387L22.5395 10.9387L21.2062 9.79582C18.7217 7.66631 17.4795 6.60156 15.9998 6.60156C14.5201 6.60156 13.2779 7.66632 10.7935 9.79582L9.46017 10.9387C8.08566 12.1168 7.3984 12.7059 7.03245 13.5016ZM18.3332 27.9999V21.3333C18.3332 21.1492 18.1839 21 17.9998 21H13.9998C13.8157 21 13.6665 21.1492 13.6665 21.3333V27.9999H18.3332Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.79ba971bf4dd042a989e0333461ad8cf.svg";
export { ForwardRef as ReactComponent };